module.exports = __webpack_public_path__ + "img/CAL-IEC-Case.cfb1a248.webp";